import { EventParticipationState } from "@/models";

export const icons = {
	[EventParticipationState.IN_PROGRESS]: ["remove"],
	[EventParticipationState.TURNED_IN]: ["assignment_turned_in"],
	[EventParticipationState.CLOSED_BY_TEACHER]: ["block"],
};
